import styles from './Layout.module.scss';

export const layoutCommonClasses = [styles.layoutViewHeight];

export const defaultClasses = {
  wrapper: styles.wrapper,
  container: 'container d-flex flex-column',
};
